var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Select from "react-select";
var defautCurentValue = "25";
var defaultLabel = "Lignes";
export var customStyles = {
    control: function (base, state) { return (__assign(__assign({}, base), { background: "none", 
        // Overwrittes the different states of border
        border: state.isFocused ? 0 : 0, 
        // Removes weird border around container
        boxShadow: state.isFocused ? null : null, fontSize: "0.8rem", text: "var(--colors-label)" })); },
    dropdownIndicator: function (base) { return (__assign(__assign({}, base), { paddingTop: 0, paddingBottom: 0, color: "var(--colors-label)", fontSize: "1.3rem", cursor: "pointer" })); },
    indicatorSeparator: function (base) { return (__assign(__assign({}, base), { display: "none" })); },
    placeholder: function (defaultStyles) {
        return __assign(__assign({}, defaultStyles), { color: "var(--colors-label)" });
    },
    valueContainer: function (provided) { return (__assign(__assign({}, provided), { minHeight: 20, paddingTop: "0", paddingBottom: 0 })); },
    singleValue: function (provided) { return (__assign(__assign({}, provided), { color: "var(--colors-label)" })); },
    option: function (provided, state) { return (__assign(__assign({}, provided), { background: "transparent", color: "var(--colors-label)", cursor: "pointer" })); },
};
/**
 *  <b>Composant de sélection de nombre de ligne à afficher pour une liste donnée</b>
 */
export var ElementPageSelector = function (_a) {
    var currentValue = _a.currentValue, _b = _a.label, label = _b === void 0 ? defaultLabel : _b, listValues = _a.listValues, className = _a.className, onChangeValue = _a.onChangeValue;
    var textLineClasses = [
        "text-[0.9rem]",
        "cursor-pointer",
        "flex flex-col md:flex-row items-start md:items-center gap-2 w-full",
    ];
    return (_jsxs("div", __assign({ className: "".concat(textLineClasses.join(" "), " ").concat(className) }, { children: [_jsx("span", __assign({ className: "flex flex-row items-center" }, { children: label })), _jsx("div", __assign({ className: "flex min-w-[40px] md:min-w-[80px]" }, { children: _jsx(Select, { options: listValues, onChange: onChangeValue, styles: customStyles, isSearchable: false, value: listValues === null || listValues === void 0 ? void 0 : listValues.find(function (item) { return item.value === String(currentValue); }), placeholder: currentValue }) }))] })));
};
